import React from "react";

export const SectionHeading = ({ overline, title, subtitle, center = true }) => (
  <div className={`max-w-2xl ${center ? "mx-auto text-center" : ""} mb-12 md:mb-16`}>
    {overline && (
      <span className="text-xs font-semibold uppercase tracking-[0.15em] text-[#B8C4A3]">{overline}</span>
    )}
    <h2 className="mt-3 font-heading text-3xl md:text-4xl font-semibold tracking-tight text-[#6F503A]">{title}</h2>
    {subtitle && <p className="mt-4 text-[#6F503A]/70 leading-relaxed">{subtitle}</p>}
  </div>
);
